import { render, staticRenderFns } from "./imc.vue?vue&type=template&id=67c74608&scoped=true&"
import script from "./imc.vue?vue&type=script&lang=ts&"
export * from "./imc.vue?vue&type=script&lang=ts&"
import style0 from "./imc.vue?vue&type=style&index=0&id=67c74608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c74608",
  null
  
)

export default component.exports